import "./polyfills";
import React from "react";
import { createRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorker";
import "./assets/base.scss";

import configureStore from "./config/configureStore";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { TradeProvider } from "./context/TradeContext"; // ✅ NEW IMPORT
import { AccountProvider } from "./context/AccountContext";

import Main from "./DemoPages/Main";

const store = configureStore();
const rootElement = document.getElementById("root");

const renderApp = (Component) => (
  <Provider store={store}>
    <BrowserRouter>
      <AuthProvider>
        <AccountProvider>
          <TradeProvider>
            <Component />
          </TradeProvider>
        </AccountProvider>
      </AuthProvider>
    </BrowserRouter>
  </Provider>
);


const root = createRoot(rootElement);
root.render(renderApp(Main));

if (module.hot) {
  module.hot.accept("./DemoPages/Main", () => {
    const NextApp = require("./DemoPages/Main").default;
    root.render(renderApp(NextApp));
  });
}

serviceWorker.unregister();
